import { z } from "zod";

// bcrypt ignores everything after 72 bytes, so longer passwords would only
// look stronger than they are.
export const PASSWORD_MAX_BYTES = 72;

const byteLength = (value: string) => new TextEncoder().encode(value).length;

export const passwordRules = [
  {
    label: "12 or more characters",
    test: (value: string) => value.length >= 12,
  },
  { label: "A number", test: (value: string) => /[0-9]/.test(value) },
  {
    label: "A symbol",
    test: (value: string) => /[^A-Za-z0-9\s]/.test(value),
  },
  {
    label: `At most ${PASSWORD_MAX_BYTES} bytes`,
    test: (value: string) => byteLength(value) <= PASSWORD_MAX_BYTES,
  },
];

export const newPasswordSchema = z
  .string()
  .min(12, "Password must be at least 12 characters long")
  .regex(/[0-9]/, "Password must contain at least one number")
  .regex(/[^A-Za-z0-9\s]/, "Password must contain at least one symbol")
  .refine(value => byteLength(value) <= PASSWORD_MAX_BYTES, {
    error: `Password must be at most ${PASSWORD_MAX_BYTES} bytes long`,
  });

export const passwordStrength = (value: string) => {
  if (!value) {
    return 0;
  }
  const passed = passwordRules.filter(rule => rule.test(value)).length;
  const lengthBonus = value.length >= 16 ? 1 : 0;
  return Math.min(100, Math.round(((passed + lengthBonus) / 5) * 100));
};
